export default "__VITE_ASSET__Co1GT_bi__"